import { useMemoryData } from "../storage/memory-storage.js";
import "mitt";
import { SimpleDataStore } from "../storage/simple-data-store.js";
import "../storage/universal-memory-storage.js";
import { ApRedux } from "./ap-redux.js";
const reduxHost = useMemoryData("redux-host", () => new SimpleDataStore());
function initializeReduxHost(initialReducers, initialState, env) {
  if (isReduxHostInitialized()) {
    throw new Error("Redux host has been initialized already.");
  }
  reduxHost().set(new ApRedux(initialReducers, initialState, env));
}
function isReduxHostInitialized() {
  return !!reduxHost().get();
}
function getReduxHost() {
  if (!isReduxHostInitialized()) {
    throw new Error(`Redux host is not initialized. Please initialize it first.`);
  }
  return reduxHost().get();
}
function getReduxStore() {
  return getReduxHost().getStore();
}
function TEST_ONLY_removeHost() {
  reduxHost().remove();
}
export {
  TEST_ONLY_removeHost,
  getReduxHost,
  getReduxStore,
  initializeReduxHost,
  isReduxHostInitialized
};
//# sourceMappingURL=redux-host.js.map
